/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

const Entities = require('html-entities').XmlEntities;
const entities = new Entities();

function SEO({ description, lang, meta, keywords, title, image, path }) {

    const { site } = useStaticQuery(
    graphql`
        query {
            site {
                siteMetadata {
                    title
                    description
                    author
                    siteUrl
                }
            }
        }
    `
    )

    const metaDescription = entities.decode(description) || site.siteMetadata.description
    let metaTitle = entities.decode(title) || site.siteMetadata.title
    const shareImageFacebook = site.siteMetadata.siteUrl+"/the-Chevron-Championship-woodland-texas-1200x630.png"
    const shareImageTwitter = site.siteMetadata.siteUrl+"/the-Chevron-Championship-woodland-texas-1080.png"

    // Add site title if not there (weird WP yoast bug)
    if (metaTitle.indexOf(site.siteMetadata.title) <= 0) {
        metaTitle = `${entities.decode(title)} - ${site.siteMetadata.title}`
    }

    // const metaUrl = url || site.siteMetadata.siteUrl

    let ogurl = site.siteMetadata.siteUrl+"/"+path
    
    return (
        <Helmet
            htmlAttributes={{
                lang,
            }}
            title={metaTitle}
            // titleTemplate={`%s | ${site.siteMetadata.title}`}
            meta={[
                {
                    name: `twitter:card`,
                    content: `summary`,
                },
                {
                    name: `twitter:creator`,
                    content: site.siteMetadata.author,
                },
                {
                    name: `twitter:title`,
                    content: title,
                },
                {
                    name: `twitter:description`,
                    content: metaDescription,
                },
            ]
                .concat(
                    keywords.length > 0
                        ? {
                            name: `keywords`,
                            content: keywords.join(`, `),
                        }
                        : []
                )
                .concat(meta)}
        >
            <script type="application/ld+json">{`
                {
                    "@context": "https://schema.org/",
                    "@type": "WebSite",
                    "name": "ANA Inspiration",
                    "url": "${process.env.GATSBY_FRONTEND_URL}"
                }
            `}
            </script>
            <script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"></script>
            <meta name="description" content={metaDescription} />
            <meta property="og:title" content={metaTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:url" content={ogurl} />
            <meta property="og:type" content="website" />
            <meta property="og:image" content={image || shareImageFacebook} />
            <meta property="twitter:image" content={image || shareImageTwitter} />
        </Helmet>
    )
}

SEO.defaultProps = {
    lang: `en`,
    meta: [],
    keywords: [],
    description: ``,
    url: ``,
    image: ``,
}

SEO.propTypes = {
    description: PropTypes.string,
    lang: PropTypes.string,
    meta: PropTypes.arrayOf(PropTypes.object),
    keywords: PropTypes.arrayOf(PropTypes.string),
    title: PropTypes.string,
    url: PropTypes.string,
    image: PropTypes.string,
}

export default SEO